// extracted by mini-css-extract-plugin
export default {"versionContainer":"styles_versionContainer__pRiAK","logo":"styles_logo__KgU+2","version":"styles_version__bHVqi"};